import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';

/** Kapcsolódó vállalkozások — logók a PandAero brand kitből (public/brand), sötét lábléc → -dark változatok. */
const partners = [
  { key: 'partnerPandaero', name: 'PandAero', href: 'https://pandaero.hu', logo: '/brand/pilot-training/pilot-training-dark.svg', alt: 'PandAero Pilot Training', width: 160 },
  { key: 'partnerOneDayPilot', name: 'One Day Pilot', href: 'https://onedaypilot.hu', logo: '/brand/onedaypilot/onedaypilot-dark.svg', alt: 'PandAero One Day Pilot', width: 215 },
  { key: 'partnerA320sim', name: 'A320 SIM Budaörs', href: 'https://a320sim.hu', logo: '/brand/a320sim/a320sim-dark.svg', alt: 'PandAero A320 SIM Budaörs', width: 180 },
  { key: 'partnerRepuloiskola', name: 'repülőiskola.hu', href: 'https://repuloiskola.hu', logo: '/brand/repuloiskola/repuloiskola-dark.svg', alt: 'repülőiskola.hu', width: 174, height: 36 },
];

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-declarations">
          <p>{t('footer.declaration1')}</p>
          <p>{t('footer.declaration2')}</p>
          <p>{t('footer.declaration3')}</p>
          <blockquote cite="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A32011R1178">
            {t('footer.regulation')}
          </blockquote>
          <nav className="footer-menu" aria-label={t('footer.menuLabel')}>
            <Link to="/easa-charter">{t('footer.charterLink')}</Link>
            <Link to="/flight-safety">{t('footer.safetyLink')}</Link>
          </nav>
        </div>
        <section className="footer-partners" aria-labelledby="footer-partners-title">
          <h2 id="footer-partners-title">{t('footer.partnersTitle')}</h2>
          <p className="footer-partners-lead">{t('footer.partnersLead')}</p>
          <div className="footer-partners-grid">
            {partners.map((p) => (
              <a key={p.href} className="footer-partner" href={p.href} target="_blank" rel="noopener noreferrer">
                <span className="footer-partner-logo">
                  <img src={p.logo} alt={p.alt} width={p.width} height={p.height || 44} style={{ height: p.height || 44 }} loading="lazy" />
                </span>
                <strong>{p.name}</strong>
                <span className="footer-partner-desc">{t(`footer.${p.key}`)}</span>
                <span className="footer-partner-domain" dir="ltr">{p.href.replace('https://', '')}</span>
              </a>
            ))}
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
